export default "__VITE_PUBLIC_ASSET__409e438b__"